module.exports = __webpack_public_path__ + "img/wall01.509d7f9e.jpg";